import { API_REFERENCE } from '../utilities/constant_api';
import {
  initializeSelectMenuCreation,
  zipCodeValidator
} from '../utilities/utility';

const addNewAdddressForm = '.checkout-add-new-address';
const editAddressBtn = '.checkout-edit-address-btn';
const sameBillingShippingAddress = '#checkoutBillingAddressCheckbox';
const clsSelectShippingAddress = '#selectShippingAddress';
const clsSelectBillingAddress = '#selectBillingAddress';
const checkoutAddressBillingSection =
  '.checkout-address-component-billing-section';
const strHidden = 'hidden';
const clsCheckoutAddressParent = '.checkout-left';
const newAddButton = '.custom-add-new-address-btn';
const hideshowShippingDetails = '.shippinng-add-details';
const hideShowBillingDetails = '.billing-add-details';
const newAddressNameValue = '.new-address-careof-value';
const newAddressLine1 = '.new-address-addressline1';
const newAddressLine2 = '.new-address-addressline2';
const newAddressCityValue = '.new-address-city-value';
const newAddressStateValue = '.new-address-state-value';
const newAddressZipValue = '.new-address-zip-value';
const checkoutNextButton = '.checkout-next-btn';
const checkoutAddressNextBtn = '.checkout-address-next';
const clsNewAddress = '.new-address';
const clsPrefShippingAddress = '.checkout-add-edit__pref-shipping';
const clsBillingAddress = '.checkout-add-edit__billing';
const clsAddEditAddress = '.checkout-add-edit-address';
const clsAddEditAddressForm = '.checkout-add-edit-address__form';
const clsAddressViewForm = '.checkout-address-view__form';
const clsAddressView = '.checkout-address-view';
const clsInputValidField = '.custom-input-valid';
const clsAddEditFormSave = '.checkout-add-edit-address__save';
const clsValidationEditBtn = '.checkout-validation-address__edit';
const clsValidationSaveBtn = '.checkout-validation-address__save';
const clsValidationParent = '.checkout-validation-address__parent';
const clsValidationRadio = '.checkout-validation-address__radio';
const clsValidationAddressBlock = '.address-block';
const clsEditAddressHeading = '.checkout-add-edit-address__edit-head';
const clsAddAddressHeading = '.checkout-add-edit-address__add-head';
const formAddressId = '#addressId';
const billingAddressTooltipId = '#checkoutBillingAddr';
const billingAddressBlockId = '#billingAddressDetails';
const shippingAddressBlockId = '#shippingAddressDetails';
const strEditBillingAddressBtn = 'editBillingAddressBtn';
const strValidationEditBtn = 'checkout-validation-address__edit';
const strValidationSaveBtn = 'checkout-validation-address__save';
const targetName = '.name';
const targetAddressOne = '.address1';
const targetAddressTwo = '.address2';
const targetCity = '.city';
const targetState = '.state';
const targetZipcode = '.zipcode';
const targetIsShipping = 'data-isShipping';
const targetIsCareOf = 'data-isCareOf';
const targetIsBilling = 'data-isBilling';
const targetAddressId = 'data-id';
const targetIsNewAddress = 'data-isNewAddress';
const saveValidatedAddressUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAddress.saveValidatedAddress}`;
const strErrorMsgTxtBox = 'error';
const billingAddressTooltip = $(billingAddressTooltipId);
let isEditing = false;
let selectedShippingAddress = '';
let selectedBillingAddress = '';
let isValidZipVal = true;
let isAddressLineVal = true;
let isCityVal = true ;
let nextStepForm = false;
const checkoutAddress = {
  inValidInput(element) {
    let returnVal = true;
    if (element.validity.valueMissing) {
      $(element)
        .siblings('.error-msg-text')
        .attr(strHidden, false);
      $(element).addClass(strErrorMsgTxtBox);
      $(element)
        .siblings('.ui-selectmenu-button')
        .addClass(strErrorMsgTxtBox);
      if ($(element).hasClass('new-address-zip-value')) {
        $(element)
          .removeClass('error-msg-textbox')
          .parent()
          .find('.invalid-zip-code-paste')
          .attr('hidden', true);
      }
      returnVal = false;
    } else {
      $(element)
        .siblings('.error-msg-text')
        .attr(strHidden, true);
      $(element).removeClass(strErrorMsgTxtBox);
      $(element)
        .siblings('.ui-selectmenu-button')
        .removeClass(strErrorMsgTxtBox);
    }

    if (
      !isValidZipVal &&
      $(element).hasClass('new-address-zip-value') &&
      $('.new-address-zip-value').val() !== ''
    ) {
      $(element)
        .addClass('error-msg-textbox')
        .parent()
        .find('.invalid-zip-code-paste')
        .attr('hidden', false);
      returnVal = false;
    }
    return returnVal;
  },

  shippingAddressDropdown(getSelectedShippingAddressId) {
    selectedShippingAddress = getSelectedShippingAddressId;
    $(hideshowShippingDetails).hide();
    $(shippingAddressBlockId)
      .find(`[data-id=${getSelectedShippingAddressId}]`)
      .show();
  },

  billingAddressDropdown(getSelectedBillingAddressId) {
    selectedBillingAddress = getSelectedBillingAddressId;
    $(hideShowBillingDetails).hide();
    $(billingAddressBlockId)
      .find(`[data-id=${getSelectedBillingAddressId}]`)
      .show();
  },

  getUserMyAddressDetails($target) {
    const obj = {};
    const isCareOf = $target.attr(targetIsCareOf);
    const isBilling = $target.attr(targetIsBilling) === 'true';
    const isShipping = $target.attr(targetIsShipping) === 'true';
    obj.name =
      isCareOf === 'true'
        ? $target
            .find(targetName)
            .text()
            .trim()
        : '';
    obj.addressLine1 = $target
      .find(targetAddressOne)
      .text()
      .trim();
    obj.addressLine2 = $target
      .find(targetAddressTwo)
      .text()
      .trim();
    obj.city = $target
      .find(targetCity)
      .text()
      .trim();
    obj.state = $target
      .find(targetState)
      .text()
      .trim();
    obj.zipCode = $target
      .find(targetZipcode)
      .text()
      .trim();
    obj.isBillingAddress = isBilling;
    obj.isShippingAddress = isShipping;
    obj.addressId = $target.attr(targetAddressId);
    obj.deliveryAddressLength = parseInt(
      $target.attr('data-addressLength'),
      10
    );
    return obj;
  },

  populatingEditForm(getData, isNewAddress) {
    if (isNewAddress) {
      $(clsAddAddressHeading).removeClass(strHidden);
      $(clsEditAddressHeading).addClass(strHidden);
    } else {
      $(clsAddAddressHeading).addClass(strHidden);
      $(clsEditAddressHeading).removeClass(strHidden);
    }
    $(newAddressNameValue).val(getData.name);
    $(newAddressLine1).val(getData.addressLine1);
    $(newAddressLine2).val(getData.addressLine2);
    $(newAddressCityValue).val(getData.city);
    $(newAddressStateValue)
      .val(getData.state)
      .selectmenu('refresh')
      .trigger('selectmenuchange');
    $(newAddressZipValue).val(getData.zipCode);
    $(formAddressId).val(getData.addressId);
  },

  checkedShippingAndBillingAddress(
    requiredBlock,
    isPopulateFormRequired,
    isAddNewAddress
  ) {
    const getData = checkoutAddress.getUserMyAddressDetails(requiredBlock);
    if (isPopulateFormRequired) {
      checkoutAddress.populatingEditForm(getData, isAddNewAddress);
    }
    const { deliveryAddressLength } = getData;
    const shippingBillingDisabled =
      (deliveryAddressLength === 1 && isEditing) || deliveryAddressLength === 0;
    const isShippingChecked =
      shippingBillingDisabled || getData.isShippingAddress;
    const isBillingChecked =
      shippingBillingDisabled || getData.isBillingAddress;
    $(`${clsNewAddress} ${clsPrefShippingAddress}`)
      .prop('checked', isShippingChecked)
      .attr('disabled', shippingBillingDisabled);
    $(`${clsNewAddress} ${clsBillingAddress}`)
      .prop('checked', isBillingChecked)
      .attr('disabled', shippingBillingDisabled);
  },

  showAddEditSection() {
    $(newAddButton).hide();
    $(checkoutNextButton).hide();

    $(clsAddressView).hide();
    $(clsAddEditAddress).show();
  },

  openAddEditAddressForm({ target }) {
    const targetId = target.id;
    const shippingParent = $(target)
      .parents(shippingAddressBlockId)
      .find(`[data-id=${selectedShippingAddress}]`);
    const billingParent = $(target)
      .parents(billingAddressBlockId)
      .find(`[data-id=${selectedBillingAddress}]`);

    let requiredBlock = shippingParent;
    let isFormToBePopulated = false;
    if (targetId === strEditBillingAddressBtn) {
      requiredBlock = billingParent;
    }
    checkoutAddress.showAddEditSection();
    if (isEditing) {
      isFormToBePopulated = true;
    } else {
      $(`${clsAddEditAddress} ${clsAddEditAddressForm}`)[0].reset();
      $(clsAddAddressHeading).removeClass(strHidden);
      $(clsEditAddressHeading).addClass(strHidden);
    }
    checkoutAddress.checkedShippingAndBillingAddress(
      requiredBlock,
      isFormToBePopulated,
      false
    );
  },

  displayBiliingAddress() {
    if ($(sameBillingShippingAddress).is(':checked')) {
      $(sameBillingShippingAddress).val(true);
      $(checkoutAddressBillingSection).addClass(strHidden);
    } else {
      $(sameBillingShippingAddress).val(false);
      $(checkoutAddressBillingSection).removeClass(strHidden);
    }
  },

  // To check on load of the page whether the shipping address and billing address are the same
  checkBillingAddressSameAsShipping() {
    const isShippingAddressSameAsBillingAddress = $(
      sameBillingShippingAddress
    ).is(':checked');
    if (!isShippingAddressSameAsBillingAddress) {
      $(checkoutAddressBillingSection).removeClass(strHidden);
    }
  },

  setShippingDefaultAddress() {
    const defaultShippingAddress = $(clsSelectShippingAddress).val();
    checkoutAddress.shippingAddressDropdown(defaultShippingAddress);
  },

  setBillingDefaultAddress() {
    const defaultBillingAddress = $(clsSelectBillingAddress).val();
    checkoutAddress.billingAddressDropdown(defaultBillingAddress);
  },

  dropdownShippingAddressChange() {
    const indexOfShippingAddId = $(this).val();
    checkoutAddress.shippingAddressDropdown(indexOfShippingAddId);
  },

  dropdownbillingAddressChange() {
    const indexOfBillingAddId = $(this).val();
    checkoutAddress.billingAddressDropdown(indexOfBillingAddId);
  },

  saveNewAddress(thisObj, actionUrl) {
    const formParent = $(thisObj).parents(clsCheckoutAddressParent);
    const saveAddressForm = formParent.find(clsAddEditAddressForm);
    $(saveAddressForm)
      .find(`${clsPrefShippingAddress},${clsBillingAddress}`)
      .attr('disabled', false);
    if (actionUrl !== '') {
      $(saveAddressForm).attr('action', actionUrl);
    }
    if (isValidZipVal) {
      setTimeout(function(){
        $(saveAddressForm).submit();
      },10);
    }
  },

  validateAddressLine(){
    isAddressLineVal = true ;
    if( $(this).val().trim() === '' || $(this).val().trim() === null){
      $(this).parent().find('.error-msg-text').attr('hidden', false);
      isAddressLineVal = false ;  
    }
  },

  validateCity(){
    isCityVal = true ;
    if( $(this).val().trim() === '' || $(this).val().trim() === null){
      $(this).parent().find('.error-msg-text').attr('hidden', false);
      isCityVal = false ;  
    }
  },

  validateForm(e) {
    e.preventDefault();
    let formSubmit = true;
    const thisObj = $(this);
    $(clsInputValidField).each((index, item) => {
      if (!checkoutAddress.inValidInput(item)) {
        formSubmit = false;
      }
    });
    if(!isAddressLineVal || !isCityVal){
      if(!isAddressLineVal){
        $(".new-address-addressline1-value").parent().find('.error-msg-text').attr('hidden', false);
      }
      if(!isCityVal){
        $(".new-address-city-value").parent().find('.error-msg-text').attr('hidden', false);
      }
      formSubmit = false;
    }
    if (formSubmit) {
      checkoutAddress.saveNewAddress(thisObj, '');
    }
  },

  continueToNextStep() {
    const thisObj = $(this);
    const formParent = thisObj.parents(clsAddressViewForm);
    if (isValidZipVal && !nextStepForm) {
      nextStepForm = true;
      $(formParent).submit();
    }
  },

  proceedAfterValidation() {
    const thisObj = $(this);
    const checkedRadioBtn = $(`${clsValidationRadio}:checked`);
    const parent = checkedRadioBtn.parents(clsValidationParent);
    const isNewAddress = $(parent).attr(targetIsNewAddress);

    // To find whether the address is a new address or an edited address
    const sectionTitle = isNewAddress === 'true';
    const addressBlock = $(parent).find(clsValidationAddressBlock);
    const isEditBtn = thisObj.hasClass(strValidationEditBtn);
    const isSaveBtn = thisObj.hasClass(strValidationSaveBtn);
    // setting the isEditing variable with the opposite of the sectionTitle const
    isEditing = !sectionTitle;
    checkoutAddress.checkedShippingAndBillingAddress(
      addressBlock,
      true,
      sectionTitle
    );
    if (isEditBtn) {
      checkoutAddress.showAddEditSection();
    } else if (isSaveBtn) {
      const actionUrl = saveValidatedAddressUrl;
      checkoutAddress.saveNewAddress(thisObj, actionUrl);
    }
  },
  validateCheckoutAddressSelectMenus() {
    const thisObj = $(this);
    const isValuePresent = thisObj[0].validity.valueMissing;
    if (!isValuePresent) {
      thisObj.siblings('.error-msg-text').attr(strHidden, true);
      thisObj.siblings('.ui-selectmenu-button').removeClass(strErrorMsgTxtBox);
    }
  },
  validationOnPaste(e) {
    let isInvalidZipCode;
    isInvalidZipCode = zipCodeValidator(e, $(this));
    $(this)
      .removeClass('error-msg-textbox')
      .parent()
      .find('.invalid-zip-code-paste')
      .attr('hidden', true);
    isValidZipVal = true;
    if (isInvalidZipCode && $(this).val() !== '') {
      $(this)
        .addClass('error-msg-textbox')
        .parent()
        .find('.invalid-zip-code-paste')
        .attr('hidden', false);
      isValidZipVal = false;
    }
  },
  init() {
    $(addNewAdddressForm).on('click', function(target) {
      isEditing = false;
      checkoutAddress.openAddEditAddressForm(target);
    });
    $(editAddressBtn).on('click', function(target) {
      isEditing = true;
      checkoutAddress.openAddEditAddressForm(target);
    });

    $(sameBillingShippingAddress).on('click', this.displayBiliingAddress);
    $(clsAddEditFormSave).on('click', this.validateForm);
    $(newAddressLine1).on('change',this.validateAddressLine);
    $(newAddressCityValue).on('change',this.validateCity);
    $(clsSelectShippingAddress).on(
      'selectmenuchange',
      this.dropdownShippingAddressChange
    );
    $(clsSelectBillingAddress).on(
      'selectmenuchange',
      this.dropdownbillingAddressChange
    );
    $(checkoutAddressNextBtn).on('click', this.continueToNextStep);
    $(`${clsValidationEditBtn},${clsValidationSaveBtn}`).on(
      'click',
      this.proceedAfterValidation
    );
    $(document).on(
      'change input',
      '.new-address-zip-value',
      this.validationOnPaste
    );
    this.checkBillingAddressSameAsShipping();
    this.setShippingDefaultAddress();
    this.setBillingDefaultAddress();
    billingAddressTooltip.tooltip();
    $(
      '.checkout-address__dropdown,#selectShippingAddress,#selectBillingAddress'
    ).selectmenu({
      classes: {
        'ui-selectmenu-open': 'checkout-address__selectmenu'
      }
    });
    $('.checkout-address__dropdown').on(
      'selectmenuchange',
      this.validateCheckoutAddressSelectMenus
    );
  }
};
checkoutAddress.init();

export default checkoutAddress;
